<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "Answers",
  mounted() {
    this.$store.commit("RESET_ANSWERS");
    this.$store.commit("RESET_ANSWER_POINTS");
  },
};
</script>

<style lang="scss">
@import "./assets/scss/variables";
@import "~bootstrap/scss/bootstrap";
@import "./assets/scss/index";
</style>
